import * as Types from '../../../gql/base-types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';

// =============================================================================
// Auto-generated by GraphQL Codegen - DO NOT EDIT
// Change the .gql source (or the schema) and re-run: pnpm codegen
// =============================================================================

const defaultOptions = {} as const;
export type GetServiceStopsMissingRoQueryVariables = Types.Exact<{
  start: Types.Scalars['timestamptz']['input'];
  end: Types.Scalars['timestamptz']['input'];
  customerId: Types.Scalars['bigint']['input'];
  limit?: Types.Scalars['Int']['input'];
}>;


export type GetServiceStopsMissingRoQuery = { __typename?: 'query_root', mobility_stops: Array<{ __typename?: 'mobility_stops', id: number, status: string, stop_order: number, address?: string | null, run: { __typename?: 'mobility_runs', id: number, status: string, departure_time?: string | null, created_at: string, driver?: { __typename?: 'drivers', id: number, user?: { __typename?: 'users', display_name: string, avatar_url?: string | null } | null } | null }, service_stop_detail: Array<{ __typename?: 'service_stop_details', stop_id: number, customer_name?: string | null, customer_phone?: string | null, service_description?: string | null, ro_reference?: string | null, estimated_service_minutes?: number | null }>, service_orders: Array<{ __typename?: 'service_orders', id: number, status: string, appointment_id?: number | null, vehicle_vin?: string | null, vehicle_make?: string | null, vehicle_model?: string | null, vehicle_year?: number | null, vehicle_color?: string | null, appointment?: { __typename?: 'appointments', id: number, ro_number?: string | null, appointment_time?: string | null, consumer_name?: string | null, consumer_phone?: string | null } | null }> }>, stopsMissingRoCount: { __typename?: 'mobility_stops_aggregate', aggregate?: { __typename?: 'mobility_stops_aggregate_fields', count: number } | null } };


export const GetServiceStopsMissingRoDocument = gql`
    query getServiceStopsMissingRo($start: timestamptz!, $end: timestamptz!, $customerId: bigint!, $limit: Int! = 200) {
  mobility_stops(
    where: {product_type: {_eq: "mobile_service"}, status: {_neq: "skipped"}, run: {customer_id: {_eq: $customerId}, status: {_neq: "cancelled"}}, service_orders: {}, _and: [{_not: {service_orders: {appointment: {ro_number: {_is_null: false}}}}}, {_not: {service_stop_detail: {ro_reference: {_is_null: false}}}}, {_or: [{run: {departure_time: {_gte: $start, _lte: $end}}}, {run: {departure_time: {_is_null: true}, created_at: {_gte: $start, _lte: $end}}}]}]}
    order_by: [{run: {departure_time: desc_nulls_last}}, {stop_order: asc}]
    limit: $limit
  ) {
    id
    status
    stop_order
    address
    run {
      id
      status
      departure_time
      created_at
      driver {
        id
        user {
          display_name
          avatar_url
        }
      }
    }
    service_stop_detail {
      stop_id
      customer_name
      customer_phone
      service_description
      ro_reference
      estimated_service_minutes
    }
    service_orders {
      id
      status
      appointment_id
      vehicle_vin
      vehicle_make
      vehicle_model
      vehicle_year
      vehicle_color
      appointment {
        id
        ro_number
        appointment_time
        consumer_name
        consumer_phone
      }
    }
  }
  stopsMissingRoCount: mobility_stops_aggregate(
    where: {product_type: {_eq: "mobile_service"}, status: {_neq: "skipped"}, run: {customer_id: {_eq: $customerId}, status: {_neq: "cancelled"}}, service_orders: {}, _and: [{_not: {service_orders: {appointment: {ro_number: {_is_null: false}}}}}, {_not: {service_stop_detail: {ro_reference: {_is_null: false}}}}, {_or: [{run: {departure_time: {_gte: $start, _lte: $end}}}, {run: {departure_time: {_is_null: true}, created_at: {_gte: $start, _lte: $end}}}]}]}
  ) {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useGetServiceStopsMissingRoQuery__
 *
 * To run a query within a React component, call `useGetServiceStopsMissingRoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetServiceStopsMissingRoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetServiceStopsMissingRoQuery({
 *   variables: {
 *      start: // value for 'start'
 *      end: // value for 'end'
 *      customerId: // value for 'customerId'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetServiceStopsMissingRoQuery(baseOptions: Apollo.QueryHookOptions<GetServiceStopsMissingRoQuery, GetServiceStopsMissingRoQueryVariables> & ({ variables: GetServiceStopsMissingRoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetServiceStopsMissingRoQuery, GetServiceStopsMissingRoQueryVariables>(GetServiceStopsMissingRoDocument, options);
      }
export function useGetServiceStopsMissingRoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetServiceStopsMissingRoQuery, GetServiceStopsMissingRoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetServiceStopsMissingRoQuery, GetServiceStopsMissingRoQueryVariables>(GetServiceStopsMissingRoDocument, options);
        }
// @ts-ignore
export function useGetServiceStopsMissingRoSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetServiceStopsMissingRoQuery, GetServiceStopsMissingRoQueryVariables>): Apollo.UseSuspenseQueryResult<GetServiceStopsMissingRoQuery, GetServiceStopsMissingRoQueryVariables>;
export function useGetServiceStopsMissingRoSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetServiceStopsMissingRoQuery, GetServiceStopsMissingRoQueryVariables>): Apollo.UseSuspenseQueryResult<GetServiceStopsMissingRoQuery | undefined, GetServiceStopsMissingRoQueryVariables>;
export function useGetServiceStopsMissingRoSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetServiceStopsMissingRoQuery, GetServiceStopsMissingRoQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetServiceStopsMissingRoQuery, GetServiceStopsMissingRoQueryVariables>(GetServiceStopsMissingRoDocument, options);
        }
export type GetServiceStopsMissingRoQueryHookResult = ReturnType<typeof useGetServiceStopsMissingRoQuery>;
export type GetServiceStopsMissingRoLazyQueryHookResult = ReturnType<typeof useGetServiceStopsMissingRoLazyQuery>;
export type GetServiceStopsMissingRoSuspenseQueryHookResult = ReturnType<typeof useGetServiceStopsMissingRoSuspenseQuery>;
export type GetServiceStopsMissingRoQueryResult = Apollo.QueryResult<GetServiceStopsMissingRoQuery, GetServiceStopsMissingRoQueryVariables>;
import { resolveExecutor, type GqlExecutor, type GqlRequestOptions } from '@hopdrive/sdk-core'


/**
 * Multiple root fields (mobility_stops, stopsMissingRoCount): returns the full response object.
 * @source {@link src/features/missingRefReport/queries/getServiceStopsMissingRo.query.gql}
 */
export async function getServiceStopsMissingRo(
  variables: GetServiceStopsMissingRoQueryVariables,
  options?: { executor?: GqlExecutor } & GqlRequestOptions
): Promise<GetServiceStopsMissingRoQuery> {
  const { executor, ...requestOptions } = options ?? {}
  return resolveExecutor(executor).query<GetServiceStopsMissingRoQuery>(
    GetServiceStopsMissingRoDocument,
    variables,
    requestOptions
  )
}